import React from "react";
import { BarChart3, FileText, Clock, Shield } from "lucide-react";

const features = [
  {
    title: "AI-Powered Trading",
    description:
      "Our bots analyze real-time data to find the best trading opportunities.",
    icon: <BarChart3 className="text-green-500 w-12 h-12"  />,
    bgColor: "bg-green-100",
  },
  {
    title: "Top-Notch Security",
    description:
      "Your funds and data are protected with the latest security tech.",
    icon: <FileText className="text-amber-500 w-12 h-12"  />,
    bgColor: "bg-amber-100",
  },
  {
    title: "Live Market Insights",
    description:
      "Stay updated with accurate charts, signals, and trading trends.",
    icon: <Clock className="text-blue-500 w-12 h-12"  />,
    bgColor: "bg-blue-100",
  },
  {
    title: "Mobile & Web Access",
    description:
      "Trade anytime, anywhere from your phone or computer.",
    icon: <Shield className="text-red-500 w-12 h-12"  />,
    bgColor: "bg-red-100",
  },
];

const Features = () => {
  return (
    <div className="flex flex-col md:flex-row  xl-px-0 px-5 py-12 gap-8 max-w-7xl mx-auto">
      <div className="md:w-1/2 space-y-4">
        <h2 className="text-5xl font-bold text-gradient-to-r from-[#263283] to-[#ed2924]">
        All-in-One Features
        </h2>
        <p className="text-slate-600 mb-6">
        At GFM, we offer more than just bots — we offer smart tools designed to boost your trading success. Every feature is built to make Forex trading easier, faster, and more rewarding.
        </p>
        <div className="relative ">
            <img className="" src="https://themes.envytheme.com/bern/wp-content/uploads/2023/07/how-it-works.png"/>
         </div>
      </div>
      <div className="md:w-1/2 space-y-4">
        {features.map((feature, index) => (
          <div
            key={index}
            className="bg-white p-6 rounded-lg shadow-sm border border-gray-100"
          >
            <div className="flex items-center">
              <div className={`${feature.bgColor} p-2  rounded-md flex items-center justify-center`}>
                {feature.icon}
              </div>
              <div className="ml-4">
                <h3 className="font-semibold text-gray-800">{feature.title}</h3>
                <p className="text-gray-500 text-sm mt-1">
                  {feature.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Features;
